export class NonChevronApplicationPermissionUpdateRequest {
    constructor(permissionUpdates: NonChevronApplicationPermissionUpdate[]) {
        this.permissionUpdates = permissionUpdates;
    }
    permissionUpdates: NonChevronApplicationPermissionUpdate[];
}

export class NonChevronApplicationPermissionUpdate
{
    constructor(permissionId: string, servicePrincipalId: string, preapproved: boolean, owners: string[]) {
        this.permissionId = permissionId;
        this.servicePrincipalId = servicePrincipalId;
        this.preapproved = preapproved;
        this.owners = owners;
    }
    permissionId: string;
    servicePrincipalId: string;
    preapproved: boolean;
    owners: string[];
}